// Full-document render of the password-reset confirm view: PageSkeleton (the
// React document shell) wrapping PasswordResetConfirmBody.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { PasswordResetConfirmBody } from "../components/PasswordResetConfirmBody";

export const Template = (
    props: templates.PasswordResetConfirmDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <PasswordResetConfirmBody {...props} />
    </PageSkeleton>
);
